import { Reducer } from "redux";
import { produce } from "immer";

import { IUserInfoLoadedAction } from "@multiweb/reactCore/bridge";
import { IAuthState } from "./types";

const INITIAL_STATE: IAuthState = {
    userId: null,
    userName: null,
    displayName: null,
};

export const reducer: Reducer<IAuthState> = (state = INITIAL_STATE, action) =>
    produce(state, (draft) => {
        if (action instanceof IUserInfoLoadedAction) {
            const { userId, userName, displayName } = action.payload.userInfo;
            draft.userId = userId;
            draft.userName = userName;
            draft.displayName = displayName;
        }
    });
